<template>
    <!-- contact form wrap -->
    <div class="contact-form-wrap">
        <div class="contact-form-overlay" @click="closeForm"></div>
        <div class="contact-form-container">
            <div class="contact-form-content fl-wrap white-bg">
                <div class="contact-form-header fl-wrap">
                    <h4>Get In Touch</h4>
                    <span class="close-cf close-contact-form" @click="closeForm">
                        <i class="fal fa-times"></i>
                    </span>
                </div>
                <div id="contact-form" class="fl-wrap">
                    <div id="message" v-if="submitMessage" :class="{ 'success-message': !submitError, 'error-message': submitError }">
                        {{ submitMessage }}
                    </div>
                    <form class="custom-form" @submit.prevent="submitForm" id="contactform">
                        <fieldset>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input 
                                        type="text" 
                                        name="name" 
                                        id="name" 
                                        placeholder="Your Name *" 
                                        v-model="formData.name"
                                        required
                                    />
                                </div>
                                <div class="col-sm-6">
                                    <input 
                                        type="email" 
                                        name="email" 
                                        id="email" 
                                        placeholder="Email Address *" 
                                        v-model="formData.email"
                                        required
                                    />
                                </div>
                                <div class="col-sm-6">
                                    <input 
                                        type="text" 
                                        name="phone" 
                                        id="phone" 
                                        placeholder="Your Phone" 
                                        v-model="formData.phone"
                                    />
                                </div>
                                <div class="col-sm-6">
                                    <div class="fl-wrap select-holder">
                                        <select id="subject" name="subject" v-model="formData.subject" required>
                                            <option value="" disabled>Subject</option>
                                            <option value="Support">Support</option>
                                            <option value="New Project">New Project</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="question">
                                <textarea 
                                    name="message" 
                                    id="comments" 
                                    cols="40" 
                                    rows="3" 
                                    placeholder="Your Message:"
                                    v-model="formData.message"
                                    required
                                ></textarea>
                            </div>
                            <button class="btn fl-btn" id="submit" type="submit" :disabled="submitting">
                                <span>{{ submitting ? 'Sending...' : 'Send Message' }}</span>
                            </button>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <!--contact form wrap end -->
</template>

<script>
export default {
    name: 'ContactFormPopup',
    data() {
        return {
            formData: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            },
            submitting: false,
            submitMessage: '',
            submitError: false
        }
    },
    mounted() {
        // Listen for the open contact form event
        const $ = window.jQuery
        if ($) {
            $(document).on('click', '.act-cf', (e) => {
                e.preventDefault()
                this.showForm()
            })
        }
    },
    methods: {
        showForm() {
            const $ = window.jQuery
            if ($) {
                const coninw = $(".contact-form-content")
                const coninbtn = $(".contact-form-btn")
                
                console.log('📧 Opening contact form')
                $(".contact-form-wrap").css('display', 'block').fadeIn(100)
                $(".contact-form-overlay").fadeIn(100)
                coninw.addClass("vis-coninfwrap")
                if (coninbtn.length) {
                    coninbtn.removeClass("isconin-btn_vis")
                }
            }
        },
        
        closeForm() {
            const $ = window.jQuery
            if ($) {
                const coninw = $(".contact-form-content")
                const coninbtn = $(".contact-form-btn")
                
                console.log('📪 Closing contact form')
                coninw.removeClass("vis-coninfwrap")
                if (coninbtn.length) {
                    coninbtn.addClass("isconin-btn_vis")
                }
                $(".contact-form-wrap").fadeOut(100)
                $(".contact-form-overlay").fadeOut(100)
                
                // Clear message after closing
                setTimeout(() => {
                    this.submitMessage = ''
                    this.submitError = false
                }, 300)
            }
        },
        
        async submitForm() {
            this.submitting = true
            this.submitMessage = ''
            this.submitError = false
            
            try {
                const response = await this.$api.post('public/submit-feedback', this.formData)
                
                if (response.data) {
                    this.submitMessage = 'Thank you! Your message has been sent successfully.'
                    this.submitError = false
                    
                    // Reset form
                    this.formData = {
                        name: '',
                        email: '',
                        phone: '',
                        subject: '',
                        message: ''
                    }
                    
                    // Close form after 2 seconds
                    setTimeout(() => {
                        this.closeForm()
                    }, 2000)
                }
            } catch (error) {
                console.error('❌ Failed to submit contact form:', error)
                
                if (error.response && error.response.data && error.response.data.errors) {
                    // Laravel validation errors
                    const errors = error.response.data.errors
                    const firstError = Object.values(errors)[0][0]
                    this.submitMessage = firstError
                } else {
                    this.submitMessage = 'Failed to send message. Please try again later.'
                }
                
                this.submitError = true
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style scoped>
#message {
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 5px;
}

#message.success-message {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

#message.error-message {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}
</style>

